import React, { Component } from 'react';
import { Context } from "context";

// import styles from 'App.module.scss';
import Editor from "editor/Editor";
import Toasts from "components/toasts/Toasts";
import VersionBanner from "components/versionBanner/VersionBanner";
import Blackout from "components/blackout/Blackout";
import Fullscreen from "react-full-screen";
import Warnings from "components/warnings/Warnings";
import Disclaimer from "components/disclaimer/Disclaimer";
import {detect} from "detect-browser";
import isTouchDevice from "is-touch-device/src";
import * as Sentry from "@sentry/browser";
import Progress from "components/progress/Progress";
import BeingPrepared from "editor/screens/BeingPrepared";
import ConversionFailed from "editor/screens/ConversionFailed";
import NoMapPacks from "editor/screens/NoMapPacks";
import NotSupported from "editor/screens/NotSupported";
import Processing from "editor/screens/Processing";
import ProcessingError from "editor/screens/ProcessingError";
import * as UIController from "controller/UIController";
import Cookies from "js-cookie";

import 'styles/themed-styles.scss';

// The screens the project-open gate shows when the editor cannot open yet. context/openFlow.js names them.
const SCREENS = {Processing, NotSupported, ProcessingError, BeingPrepared, ConversionFailed, NoMapPacks};

export default class App extends Component {
    static contextType = Context;

    async componentDidMount() {
        if (Cookies.get('lightTheme')) this.context.setLightTheme(JSON.parse(Cookies.get('lightTheme')))
        this.displayBrowserWarning();
        this.displayTouchWarning();
        this.setSentryTags();
    }

    displayBrowserWarning = () => {
        const browser = detect();
        if(browser.name !== "chrome") {
            this.context.alert(this.context.text.copy.browserWarning, "neutral");
        }
    }

    displayTouchWarning = () => {
        if (isTouchDevice()) {
            this.context.alert(this.context.text.copy.touchWarning, "neutral")
        }
    }

    setSentryTags = () => {
        const url = new URL(window.location);
        const projectId = url.pathname.split("/")[1];

        Sentry.setExtra("project_id", projectId);
        if(this.context.user) {
            const {id, username, fullName} = this.context.user;
            Sentry.setUser({id, username, fullName});
        }
    }

    render() {
        const url = new URL(window.location);
        const projectId = url.pathname.split("/")[1];
        const disclaimerConfirmed = UIController.isDisclaimerConfirmed(projectId);
        if(!this.context.disclaimerConfirmed && disclaimerConfirmed) this.context.confirmDisclaimer();
        if (!this.context.disclaimerConfirmed && !disclaimerConfirmed) return <Disclaimer/>;

        if (this.context.screen) {
            const OpenScreen = SCREENS[this.context.screen.name];
            return (
                <div className={`${this.context.lightTheme ? "light" : "dark"} app`}>
                    <Toasts/>
                    <VersionBanner/>
                    <OpenScreen {...this.context.screen.props}/>
                </div>
            );
        }

        if (this.context.loaded) return (
            <Fullscreen enabled={this.context.fullScreen} onChange={this.context.setFullScreen}>
                <div className={`${this.context.lightTheme ? "light" : "dark"} app`}>
                    <Toasts/>
                    <VersionBanner/>
                    <Blackout/>
                    <Warnings/>
                    <Editor/>
                </div>
            </Fullscreen>
    );

        // The reads of the stored layout run on this path and the read limit can pause them: its toast (and any other) has to be seen while the bar waits.
        // Toasts come after Progress: both are z-index 100 (the progress screen is fixed and opaque), so at equal z-index the later element paints on top.
        return (
            <div className={`${this.context.lightTheme ? "light" : "dark"} app`}>
                <Progress/>
                <Toasts/>
            </div>
        );
    }

}
